import CalendarService from '../lib/services/CalendarService';

interface Params {
  symbol: string;
  dateRange: {
    date_to: Date;
    date_from: Date;
  };
}

const fetchInsiderTrades = (params: Params): Promise<any> => {
  const query = {
    company_ticker: params.symbol,
    filing_date_end: params?.dateRange?.date_to,
    filing_date_preset: 'custom',
    filing_date_start: params?.dateRange?.date_from,
    group_by: 'filing',
    page_limit: 10000,
    sort_by: 'last_filing_date',
    trade_date_preset: 'custom',
    trade_types: ['p', 's'],
  };

  const Calendar = new CalendarService();

  return Calendar.getInsiderTrades(query).then(({ data }: any) => {
    return data.filings;
  });
};

export { fetchInsiderTrades };
